import { Component, OnInit } from '@angular/core';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ModuleType } from '@fi-shared/types';

@Component({
    selector: 'fi-customer-billing-customer-unit-list-state',
    template: ` <fi-customer-billing-customer-unit-list> </fi-customer-billing-customer-unit-list> `,
    standalone: false,
})
export class CustomerBillingCustomerUnitListStateComponent implements OnInit {
    constructor(
        private tabsModuleService: TabsModuleService,
        private statisticService: StatisticService,
    ) {}

    ngOnInit(): void {
        this.statisticService.Visit(ModuleType.Billing);
    }
}
